import Lazyload from 'lazyload';
import $ from 'jquery';
import Swiper from 'swiper';
import 'swiper/css';
import '../scss/imageDetail.scss';
import { fetchAddReadCountByLog, fetchSiteJson } from '../apis/api';
import { nativePreviewImage } from './appSdk';
import {
  browerVersion,
  getSingleValueFromInput,
  getUrlQuery,
  initYoumeng,
  isHideDownloadGuide,
} from './utils';
import initWxSdk from './wxSdk';

const version = browerVersion();

const initSwiper = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const swiper = new Swiper('#image-swiper', {
    loop: true,
  });
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const initImageClick = () => {
  const newsImages = $('#image-swiper').find('.image-image');
  const swiperSlides = $('#image-swiper').find('.swiper-slide');
  const imgList: { title: string; url: string }[] = [];
  swiperSlides.each((index, el) => {
    const title = $(el).find('image-title').text();
    const images = $(el).find('.image-image');
    if (images.length) {
      const image = images[0] as HTMLImageElement;
      imgList.push({ url: image.srcset || image.src, title });
    }
  });
  newsImages.on('click', (evt) => {
    const target = evt.target as HTMLImageElement;
    const url = target.srcset || target.src;
    let index = imgList.findIndex((item) => item.url === url);
    if (index === -1) {
      index = 0;
    }
    if (version.myApp) {
      nativePreviewImage(imgList, index);
    } else if (version.weixin) {
      const urls = imgList.map((item) => item.url);
      wx.previewImage({
        urls,
        current: urls[index],
      });
    }
  });
};

/**
 * 初始化sitejson
 */
const initSiteJson = () => {
  if (!version.myApp && version.mobile) {
    fetchSiteJson().then((res: Site.SiteJson) => {
      if (isHideDownloadGuide()) {
        return;
      }
      const headerGuideBox = $('#header-guide-box');
      if (!headerGuideBox || !res.name) {
        return;
      }
      // 设置下载链接
      headerGuideBox
        .find('a[name="download-link"]')
        .attr('data-href', res.downloadUrl)
        .attr('alt', res.name);
      // 设置引导图片
      headerGuideBox
        .find('img[name=guide-image]')
        .attr('src', res.guidePic)
        .attr('alt', res.name);
      headerGuideBox.find('img[name=guide-image]').on('load', (evt) => {
        const { clientWidth } = document.body;
        let imageHeight = '';
        let imageWidth = '';
        const { naturalHeight, naturalWidth } =
          evt.currentTarget as HTMLImageElement;
        if (clientWidth > 650) {
          imageWidth = '650px';
          imageHeight = `${(650 / naturalWidth) * naturalHeight}px`;
        } else {
          imageWidth = `${clientWidth}px`;
          imageHeight = `${(clientWidth / naturalWidth) * naturalHeight}px`;
        }
        $(evt.currentTarget).css({
          height: imageHeight,
          width: imageWidth,
        });
        initWxSdk({
          launchAppBtn: [
            {
              attr: 'id',
              value: 'header-guide-box',
            },
          ],
        });
      });
      // 点击关闭按钮的事件
      headerGuideBox.find('img[name="close-guide"]').each((index, el) => {
        $(el).on('click', (evt) => {
          evt.preventDefault();
          evt.stopPropagation();
          headerGuideBox.hide();
        });
      });
    });
  }
};

const addReadCount = () => {
  const newsId = getSingleValueFromInput('newsId');
  const contentType = getSingleValueFromInput('contentType');
  const siteId = getSingleValueFromInput('siteId');
  if (newsId && contentType && siteId) {
    fetchAddReadCountByLog(newsId, Number(contentType), siteId);
  }
};

(() => {
  const staticType = Number(getSingleValueFromInput('staticType'));
  if (!Number(staticType)) {
    const query = getUrlQuery();
    if (!Number(query.isMobile)) {
      const previewSubtitle = $('.preview-subtitle');
      if (previewSubtitle) {
        previewSubtitle.show();
      }
      const previewKeyword = $('.preview-keyword');
      if (previewKeyword) {
        previewKeyword.show();
      }
      const previewDescription = $('.preview-description');
      if (previewDescription) {
        previewDescription.show();
      }
    }
  }
  initSiteJson();
  initSwiper();
  // initImageClick();
  addReadCount();
  initYoumeng();
  // eslint-disable-next-line no-new
  new Lazyload();
  initWxSdk({
    wxShare: {
      title: getSingleValueFromInput('shareTitle') || document.title,
      desc: getSingleValueFromInput('shareDesc') || '',
      imgUrl: (getSingleValueFromInput('shareImgUrl') ||
        process.env.DEFAULT_SHARE_IMAGE) as string,
    },
  });
})();
